import { AuthService } from "./../../services/authService";
import { CoreService } from "./../../services/coreService";
import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import {
  distinctUntilChanged,
  debounceTime,
  takeWhile,
  tap,
  switchMap,
  map,
  catchError,
  finalize,
} from "rxjs/operators";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { Icons, IconCss, UserGroups } from "../../../assets/config/models";
import { Subject } from "rxjs";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ParkingStaffModalComponent } from "../parking-staff-modal/parking-staff-modal.component";
import { AddStaffModalComponent } from "../add-staff-modal/add-staff-modal.component";
import { ChangeUserPasswordComponent } from "../change-user-password/change-user-password.component";
import { EditParkingStaffModalComponent } from "../edit-parking-staff-modal/edit-parking-staff-modal.component";
import { MakeStaffModalComponent } from "../make-staff-modal/make-staff-modal.component";
import { CommonModule } from "@angular/common";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";

declare var toastr: any;

@Component({
  selector: "parking-place-parking-staffs",
  templateUrl: "./parking-place-parking-staffs.component.html",
  styleUrls: ["./parking-place-parking-staffs.component.scss"],
  providers: [CoreService, AuthService],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NgxDatatableModule],
})
export class ParkingPlaceParkingStaffsComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input()
  id;
  @Input()
  group;
  groupTypes = UserGroups;
  selectedUser;
  loading = false;
  sortIcons = Icons;
  sortColumns = [];
  sorts = { prop: "", dir: "" };
  form: UntypedFormGroup;
  page = {
    //The number of elements in the page
    size: 0,
    //The total number of elements
    totalElements: 0,
    //The current page number
    pageNumber: 0,
  };
  icons = IconCss;
  iconsCss = {
    pagerLeftArrow: this.icons.left,
    pagerRightArrow: this.icons.right,
    pagerPrevious: this.icons.previous,
    pagerNext: this.icons.next,
  };
  isLoading = false;
  rows = [];
  staffs$ = new Subject<{ offset: number }>();
  formChanges$;
  dialogRef: MatDialogRef<any>;

  constructor(
    public coreService: CoreService,
    private builder: UntypedFormBuilder,
    private authService: AuthService,
    public dialog: MatDialog,
  ) {
    this.form = this.builder.group({
      name: [""],
    });
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.staffs$
      .pipe(
        tap((val) => {
          console.log("I should be loading I suppose");
          this.isLoading = true;
          this.page.pageNumber = val.offset;
        }),
        switchMap((val) => {
          return this.coreService.GetParkingPlaceStaffs(
            {
              offset: this.page.pageNumber * this.page.size,
              limit: this.page.size,
            },
            this.form.controls,
            this.sorts,
            this.id,
          );
        }),

        catchError((e) => {
          this.isLoading = false;
          return this.coreService.handleObservableError(e);
        }),
      )
      .subscribe((response: any) => {
        this.rows = response.data;
        this.page.totalElements = response.total_list;
        this.isLoading = false;
      });
    this.setSort();
  }

  resetFilters() {
    this.form.reset();
    this.sorts = { prop: "", dir: "" };
    this.setSort();
  }

  getIcon(prop) {
    return this.sortColumns.find((element) => element.prop == prop).icon;
  }

  setSort() {
    this.sortColumns = [];
    for (let key of Object.keys(this.form.value)) {
      this.sortColumns.push({
        prop: key,
        icon: this.sortIcons.none,
      });
    }
    this.sortColumns.push({
      prop: "role",
      icon: this.sortIcons.none,
    });
  }

  onSort(event) {
    console.log("event", event);
    this.sorts = event.sorts[0];
    this.setSort();
    let icon;
    switch (event.sorts[0].dir) {
      case "asc": {
        icon = this.sortIcons.asc;
        break;
      }
      case "desc": {
        icon = this.sortIcons.desc;
        break;
      }
      default: {
        icon = this.sortIcons.none;
        break;
      }
    }
    this.sortColumns.find(
      (element) => element.prop == event.sorts[0].prop,
    ).icon = icon;
    this.staffs$.next({ offset: 0 });
  }

  openModal(source, user?) {
    switch (source) {
      case "assign": {
        this.dialogRef = this.dialog.open(ParkingStaffModalComponent, {
          data: {
            parkingID: this.id,
          },
        });
        break;
      }
      case "create": {
        this.dialogRef = this.dialog.open(AddStaffModalComponent, {
          data: {
            parkingID: this.id,
          },
          height: "65vh",
        });
        break;
      }
      case "make": {
        this.dialogRef = this.dialog.open(MakeStaffModalComponent, {
          data: {
            parkingID: this.id,
          },
          height: "35vh",
        });
        break;
      }

      case "password": {
        this.selectedUser = user;
        this.dialogRef = this.dialog.open(ChangeUserPasswordComponent, {
          data: {
            user: this.selectedUser,
            showGeneratePassword: true,
          },
        });
        break;
      }
      case "edit": {
        this.selectedUser = user;
        this.dialogRef = this.dialog.open(EditParkingStaffModalComponent, {
          data: {
            parkingID: this.id,
            staff: this.selectedUser,
          },
        });
        break;
      }
      default: {
        break;
      }
    }

    this.dialogRef.afterClosed().subscribe((result) => {
      console.log("Result from modal is", result);
      if (result) {
        this.handleModal(source, result);
      }
    });
  }

  handleModal(source, event) {
    switch (source) {
      case "assign": {
        this.assignStaff(event);
        break;
      }
      case "create": {
        this.createStaff(event);
        break;
      }
      case "make": {
        this.makeStaff(event);
        break;
      }
      case "password": {
        this.changePassword(event);
        break;
      }
      case "edit": {
        this.editStaff(event);
        break;
      }
      default: {
        break;
      }
    }
  }

  async assignStaff(form) {
    try {
      await this.coreService.AssignStaff(form);
      toastr.success("", "Assigned staff successfully.", {
        timeOut: 2000,
      });
      this.staffs$.next({ offset: 0 });
    } catch (err) {
      toastr.error(
        "",
        // tslint:disable-next-line:no-non-null-assertion
        err!.errors!.non_field_errors[0] || "Failed to assign staff.",
        { timeOut: 2000 },
      );
    }
  }

  createStaff(form: any) {
    console.dir(form);

    this.authService
      .createStaff(form)
      .pipe(
        finalize(() => {
          this.staffs$.next({ offset: 0 });
        }),
      )
      .subscribe({
        next: () => {
          toastr.success("", "Created staff successfully.", {
            timeOut: 2000,
          });
        },
        error: () => {
          toastr.error("", "Failed to create staff.", {
            timeOut: 2000,
          });
        },
      });
  }

  makeStaff(form: any) {
    console.dir(form);

    this.authService
      .makeStaff(form)
      .pipe(
        finalize(() => {
          this.staffs$.next({ offset: 0 });
        }),
      )
      .subscribe({
        next: (result) => {
          toastr.success("", `${result.msg}`, {
            timeOut: 2000,
          });
        },
        error: (err) => {
          toastr.error("", `${err?.error?.message?.[0]}`, {
            timeOut: 2000,
          });
        },
      });
  }

  editStaff({ form, userID }: { form: any; userID: any }) {
    console.dir(form);
    console.log("user ID", userID);

    this.authService
      .editStaff(form, userID)
      .pipe(
        finalize(() => {
          this.staffs$.next({ offset: 0 });
        }),
      )
      .subscribe({
        next: () => {
          toastr.success("", "Edited staff successfully.", {
            timeOut: 2000,
          });
        },
        error: () => {
          toastr.error("", "Failed to edit staff.", {
            timeOut: 2000,
          });
        },
      });
  }

  changePassword(event) {
    this.coreService
      .UpdateUserPassword(event)
      .then((response) => {
        console.log(response);
        toastr.success("", "Successfully changed password", {
          timeOut: 2000,
        });
      })
      .catch((err) => {
        console.log(err);
        toastr.error("", "Error in changing password", {
          timeOut: 2000,
        });
      });
  }

  deleteParkingStaff(id) {
    if (confirm("Are you sure you want to delete staff?")) {
      // this.iLoader = true;
      this.coreService.DeleteParkingStaff(id).then((result) => {
        this.staffs$.next({ offset: 0 });
        toastr.success("", "Staff Deleted.", { timeOut: 2000 });
      });
    }
  }

  ngOnInit() {
    this.formChanges$ = this.form.valueChanges
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((form) => {
        this.staffs$.next({ offset: 0 });
      });
  }

  ngOnDestroy(): void {
    this.staffs$.unsubscribe();
    this.formChanges$.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
    if (changes.id.currentValue != null) {
      console.log("Am calling next");
      this.staffs$.next({ offset: 0 });
    }
  }
}
